import AllOrders from "./AllOrders"
import Buses from "./Buses"
import Warehouse from "./Warehouse"
import OldOrders from "./OldOrders"
import "../../../assets/css/order-life-cycle.css"

const LoadLifeCycle = () => {
  return (
    <div className='order-life-cycle-container'>
      <AllOrders />
      <Buses />
      <Warehouse />
      <OldOrders />
    </div>
  )
}

export default LoadLifeCycle
